import { css } from '@emotion/react'
import { InterpolationPrimitive } from '@emotion/serialize'
import styled from '@emotion/styled'
import { Text } from 'components/Typography'
import { ReactNode } from 'react'
import { BREAKPOINTS } from 'utils/styled'

const SLogoWrapper = styled.div<{ logoMaxHeightInRem?: number }>`
  margin-bottom: 1rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  & img {
    max-width: 100%;
    height: 100%;
    object-fit: contain;
    ${({ logoMaxHeightInRem }) => logoMaxHeightInRem && `max-height: ${logoMaxHeightInRem}rem;`})}
  }
`

export function MediaMentionItem(props: {
  name: string
  src: string
  href: string
  quote?: ReactNode
  className?: string
  narrowText?: boolean
  logoMaxHeightInRem?: number
  logoCss?: InterpolationPrimitive
}) {
  // Replace new line symbols
  let quote = props.quote
  if (quote && typeof quote === 'string' && quote?.replace) {
    quote = quote.replace(/\\n/g, '\n')
  }

  return (
    <a
      href={props.href}
      css={css`
        text-decoration: none;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        max-width: 100%;

        &:visited {
          color: inherit;
        }

        &:hover p {
          text-decoration: underline;
        }

        @media ${BREAKPOINTS.MD.max} {
          align-items: center;
        }
      `}
      target="_blank"
      rel="noreferrer"
    >
      <SLogoWrapper
        css={props.logoCss}
        className={props.className}
        logoMaxHeightInRem={props.logoMaxHeightInRem}
      >
        <img src={props.src} alt={props.name} />
      </SLogoWrapper>

      <Text css={{ maxWidth: props.narrowText ? '14.25rem' : '15.375rem' }}>{quote}</Text>
    </a>
  )
}
